<div class="login-hero recovery-hero">
  <div class="login-backdrop"></div>
  <div class="login-card recovery-card">
    <div class="recovery-card__content">
      <img
        src="assets/images/img-01.png"
        alt="TBAGROSENSOR"
        class="recovery-logo"
      />
      <h2 class="recovery-title">Restablecer contraseña</h2>

      <p
        *ngIf="message"
        class="recovery-message"
        [class.is-success]="status === 'success'"
        [class.is-error]="status === 'error'"
      >
        {{ message }}
      </p>

      <form
        *ngIf="status === 'ready'"
        [formGroup]="form"
        (ngSubmit)="submit()"
        class="recovery-form"
      >
        <mat-form-field appearance="outline" class="recovery-field">
          <mat-label>Nueva contraseña</mat-label>
          <mat-icon matPrefix>lock</mat-icon>
          <input matInput type="password" formControlName="password" required />
          <mat-error *ngIf="form.get('password')?.invalid">
            La contraseña debe tener al menos 8 caracteres.
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="recovery-field">
          <mat-label>Confirmar contraseña</mat-label>
          <mat-icon matPrefix>lock</mat-icon>
          <input
            matInput
            type="password"
            formControlName="confirmPassword"
            required
          />
          <mat-error *ngIf="form.hasError('mismatch')">
            Las contraseñas no coinciden.
          </mat-error>
        </mat-form-field>

        <div class="recovery-error" *ngIf="error">{{ error }}</div>

        <button
          mat-flat-button
          color="primary"
          class="recovery-submit"
          type="submit"
          [disabled]="loading || form.invalid"
        >
          {{ loading ? 'Guardando...' : 'Guardar contraseña' }}
        </button>
      </form>
    </div>
  </div>
</div>
